import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { fetchMenu } from 'actions/menu';
import Menu from '../components/Menu';
import { selectIsMenuVisible, selectMenuData, selectMenuIdle } from 'reducers/menu/selectors';
import { selectIsSomeOverlayOpen } from 'reducers/app/selectors';
import dashboardTagUrl from 'components/Menu/dashboard-tag-url';
import { isString } from 'lodash';

const URL_EXEPTIONS = { ...dashboardTagUrl, VOD: /^\/vod/, LIVE_TV: /player\/channel/ };

const MenuContainer = (props) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const isPlayer = match.url.includes('player');
  const menuData = useSelector(selectMenuData);
  const idle = useSelector(selectMenuIdle);
  const isVisible = useSelector(selectIsMenuVisible);
  // for channel player
  const isSomeOverlayOpen = useSelector(selectIsSomeOverlayOpen);
  const menuItems = useMemo(() => {
    return menuData.map((item) => {
      const itemUrl = URL_EXEPTIONS[item.dashboardTag] || `/${item.dashboardTag.toLowerCase()}`;
      const active = (isString(itemUrl) ? new RegExp(`^${itemUrl}$`) : itemUrl).test(match.url);

      return { ...item, active };
    });
  }, [menuData, match]);

  useEffect(() => {
    if (isEmpty(menuItems)) dispatch(fetchMenu());
  }, [dispatch, menuItems]);

  if (isSomeOverlayOpen || !isVisible) return null;

  return <Menu menuItems={menuItems} isPlayer={isPlayer} idle={idle} {...props} />;
};

export default MenuContainer;
